// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.P7HOjXkbeAJ0R8 {
  margin: var(--ds-space-300, 24px) var(--ds-space-0, 0);
  font-weight: var(--ds-font-weight-bold, bold);
  text-align: center;
}
._RZAXOuFDEJR3B {
  padding: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noResults": `P7HOjXkbeAJ0R8`,
	"searchResults": `_RZAXOuFDEJR3B`
};
export default ___CSS_LOADER_EXPORT___;
